// Mappe les erreurs du service « Mes magasins » vers une clé de traduction
export function storeErrorKey(e) {
  const d = e?.response?.data?.detail;
  if (d === "geo_not_configured") return "st_not_configured";
  if (d === "geo_quota" || e?.response?.status === 429) return "st_quota";
  return "st_provider_error";
}
